import { Box } from '@mantine/core';

export type DropIndicatorProps = {
  edge: 'top' | 'bottom' | 'left' | 'right';
  gap: number;
};

/**
 * DropIndicator component
 * This component is used to render the drop indicator between two items.
 */
export const DropIndicator: React.FC<DropIndicatorProps> = ({ edge }) => (
  <Box
    sx={theme => ({
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      zIndex: 10,
      pointerEvents: 'none',

      '::before': {
        top: edge === 'top' ? '-1px' : undefined,
        bottom: edge === 'bottom' ? '-1px' : undefined,
        width: '100%',
        height: '2px',
        content: '""',
        position: 'absolute',
        backgroundColor: theme.colors.gray[3],
      },
    })}
  />
);
